import React from 'react';
import { Box } from '@mui/material';
import { useCarouselStyleConfig } from '../../../hooks/useCarouselStyleConfig';
import { useDeviceType } from '../../../hooks/useDeviceType';
import { isReactNativeWebView } from '../../../services/sendBrowserEvent.service';
import { getProductsCountBasedOnDeviceType } from '../../../utils/common.util';
import { ProductCardVariant } from '../../../utils/constants';
import ProductCarousel from '../../productCarousel/component';
import ProductListCarousel from '../../productList/component';
import { SkeletonWrapper, StyledCarouselContainer } from '../style';
import { SkeletonCard } from './SkeletonCard';

interface ProductCardSkeletonLoaderProps {
  countryCode?: string;
}

export const ProductCardSkeletonLoader: React.FC<ProductCardSkeletonLoaderProps> = ({ countryCode }) => {
  const searchParams = new URLSearchParams(window.location.search);
  const platform = isReactNativeWebView() ? 'app' : 'web';

  const deviceType = useDeviceType();

  const isVerticalScroll = searchParams.get('isVerticalScroll');
  const verticalList = isVerticalScroll === 'true' ? true : false;

  const itemsPerRow = getProductsCountBasedOnDeviceType(deviceType, verticalList);

  const type = searchParams.get('type') || '';
  const productVariant = searchParams.get('productVariant') || ProductCardVariant.NORMAL;

  const styleConfig = useCarouselStyleConfig({
    carouselType: type ?? '',
    platform: platform,
    productCardVariant: productVariant as ProductCardVariant,
  });

  return (
    <StyledCarouselContainer type={type} ref={deviceType.ref}>
      <SkeletonWrapper>
        {verticalList ? (
          <ProductListCarousel
            slides={[...Array(itemsPerRow)].map((_, index) => (
              <Box key={index}>
                <SkeletonCard productVariant={productVariant as ProductCardVariant} verticalList={verticalList} countryCode={countryCode}/>
              </Box>
            ))}
            title={''}
          />
        ) : (
          <ProductCarousel
            slides={[...Array(itemsPerRow)].map((_, index) => (
              <Box key={index}>
                <SkeletonCard productVariant={productVariant as ProductCardVariant} verticalList={verticalList} countryCode={countryCode}/>
              </Box>
            ))}
            options={{ align: 'start' }}
            settings={{
              gap: styleConfig.gap,
              slidesPerView: styleConfig.slidesPerView,
              responsive: styleConfig.responsive,
            }}
          />
        )}
      </SkeletonWrapper>
    </StyledCarouselContainer>
  );
};
